import { useCallback } from 'react';
import ExportXlsx from '../../../../utils/ExportXlsx';
import getCurrentDateWithHyphen from '../../../../utils/getCurrentDateWithHyphen';
import { MappedClientUserType } from '../../types';

interface UseDownloadExcelI {
  fullUsers: MappedClientUserType[];
}

export default function useDownloadExcel({ fullUsers }: UseDownloadExcelI) {
  const downloadExcel = useCallback(() => {
    const mappedUsers = fullUsers.map((user) => ({
      Nome: user.name,
      Email: user.email,
      CPF: user.cpf,
      Tipo: user.type,
    }));

    const currentDate = getCurrentDateWithHyphen();
    ExportXlsx({
      filename: `Usuários Acesso Sismob - ${currentDate}`,
      data: mappedUsers,
    });
  }, [fullUsers]);

  return { downloadExcel };
}
